import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

const ReviewSlider = () => {
    return (
        <div className="flex items-center justify-center py-[96px] bg-[#F9FAFB] w-full max-2xl:px-[7.7vw] max-w-[1600px]">
            <Swiper pagination={true} loop={true} modules={[Pagination]} className='review__slider'>
                <SwiperSlide className='flex flex-col items-center justify-center gap-[32px] w-full px-[24px]'>
                    <h3 className='text-[36px] font-[500] text-center max-w-[1024px] text-[#101828] max-2xl:text-[32px] max-xl:text-[28px] max-lg:text-[24px] max-sm:text-[20px]'>
                        From start to finish, Certified DJs provided top-notch service; their attention to detail and skilled DJs ensured our fundraiser event was a hit with all our guests.!
                    </h3>
                    <div className="flex flex-col gap-[16px] items-center">
                        <img src="/images/client1.png" className='object-cover w-[64px] h-[64px]' alt="" />
                        <div className="flex flex-col gap-[4px]">
                            <span className='text-center text-[18px] text-[#101828] font-[600]'>
                                Jason Clark
                            </span>
                            <span className='text-[#475467]'>
                                Manager at Harmony Horizon
                            </span>
                        </div>
                        <div className="flex items-center gap-[4px]">
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                        </div>
                    </div>
                </SwiperSlide>
                {/* <SwiperSlide className='flex flex-col items-center justify-center gap-[32px] w-full px-[24px]'>
                    <h3 className='text-[36px] font-[500] text-center max-w-[1024px] text-[#101828] max-2xl:text-[32px] max-xl:text-[28px] max-lg:text-[24px] max-sm:text-[20px]'>
                        Transforming DJ gigs into grand experiences with seamless bookings and all-in-one lifestyle management.
                    </h3>
                    <div className="flex flex-col gap-[16px] items-center">
                        <img src="/images/client1.png" className='object-cover w-[64px] h-[64px]' alt="" />
                        <div className="flex flex-col gap-[4px]">
                            <span className='text-center text-[18px] text-[#101828] font-[600]'>
                                Caitlyn J
                            </span>
                            <span className='text-[#475467]'>
                                Dj at Galactic Rhythms
                            </span>
                        </div>
                        <div className="flex items-center gap-[4px]">
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className='flex flex-col items-center justify-center gap-[32px] w-full px-[24px]'>
                    <h3 className='text-[36px] font-[500] text-center max-w-[1024px] text-[#101828] max-2xl:text-[32px] max-xl:text-[28px] max-lg:text-[24px] max-sm:text-[20px]'>
                        Transforming DJ gigs into grand experiences with seamless bookings and all-in-one lifestyle management.
                    </h3>
                    <div className="flex flex-col gap-[16px] items-center">
                        <img src="/images/client1.png" className='object-cover w-[64px] h-[64px]' alt="" />
                        <div className="flex flex-col gap-[4px]">
                            <span className='text-center text-[18px] text-[#101828] font-[600]'>
                                Caitlyn J
                            </span>
                            <span className='text-[#475467]'>
                                Dj at Galactic Rhythms
                            </span>
                        </div>
                        <div className="flex items-center gap-[4px]">
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                            <i className="ri-star-fill text-[#FEC84B]"></i>
                        </div>
                    </div>
                </SwiperSlide> */}
            </Swiper>
        </div>
    )
}

export default ReviewSlider;